import { MessageAPI } from './types'
import queryString from 'query-string'
import dayjs from 'dayjs'
import { decamelizeKeys, filterQueryParams } from '@/utils'

export const messageApi: MessageAPI = ky => {
  return {
    async types() {
      return await ky('message/type/', {
        method: 'get'
      }).json()
    },
    async messages({ cursor, isUnread }) {
      const params = decamelizeKeys(filterQueryParams({ cursor, isUnread }))
      return await ky('message/', {
        method: 'get',
        searchParams: queryString.stringify(params)
      }).json()
    },
    async post(message) {
      return await ky('message/', {
        method: 'post',
        body: JSON.stringify(message)
      }).json()
    },
    async patchRead({ id, autoMarkAsRead = true }) {
      return await ky(`message/user/${id}/`, {
        method: 'patch',
        body: JSON.stringify({
          isRead: true,
          readDatetime: dayjs().format('YYYY-MM-DD HH:mm:ssZ'),
          autoMarkAsRead
        })
      }).json()
    }
  }
}
